import { createSlice } from "@reduxjs/toolkit";
import secureLocalStorage from "react-secure-storage";

export const AUTH_LOCAL_VARIABLES = {
  active: "mx-active",
  csrf: "csrf",
  auth_token: "authorization",
  user: "mx-user",
  session_token: "mxsxn",
  REGION: "mxr",
  REGIONS: "mxrs",
};

const INITIAL_STATE = {
  csrfToken: null,
  authToken:
    secureLocalStorage.getItem(AUTH_LOCAL_VARIABLES.auth_token) || null,
  currentUser: secureLocalStorage.getItem(AUTH_LOCAL_VARIABLES.user) || null,
  isLoggedIn: false,
  form: {},
};

const authSlice = createSlice({
  name: "auth",
  initialState: INITIAL_STATE,
  reducers: {
    InitAuth: (state) => {
      state.csrfToken =
        secureLocalStorage.getItem(AUTH_LOCAL_VARIABLES.csrf) || null;
      state.authToken =
        secureLocalStorage.getItem(AUTH_LOCAL_VARIABLES.auth_token) || null;
    },
    setCsrfToken: (state, { payload }) => {
      state.csrfToken = payload;
      secureLocalStorage.setItem(AUTH_LOCAL_VARIABLES.csrf, payload);
    },
    setCurrentUser: (state, { payload }) => {
      state.currentUser = payload;
      secureLocalStorage.setItem(AUTH_LOCAL_VARIABLES.user, payload);
    },
    setAuthToken: (state, { payload }) => {
      state.authToken = payload;
      secureLocalStorage.setItem(AUTH_LOCAL_VARIABLES.auth_token, payload);
      sessionStorage.setItem(
        AUTH_LOCAL_VARIABLES.session_token,
        "yes user is valid"
      );
    },
    setLoggedIn: (state, { payload }) => {
      state.isLoggedIn = payload;
    },
    setFormFields: (state, { payload }) => {
      state.form = payload;
    },
    clearAuth: (state, { payload }) => {
      state.currentUser = null;
      state.authToken = null;
      state.csrfToken = null;
      state.isLoggedIn = false;
      secureLocalStorage.clear();
      sessionStorage.clear();
    },
  },
});

export const authReducer = authSlice.reducer;
export const {
  InitAuth,
  setLoggedIn,
  setCsrfToken,
  setAuthToken,
  clearAuth,
  setCurrentUser,
  setFormFields,
} = authSlice.actions;
export default authSlice;
